// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__bmvzR","popup":"styles_popup__nLCzG","content":"styles_content__1rKnF","close":"styles_close__9SMCt"};